'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'infographicVideo', () => ({

		iframe        : null,
		figure        : null,
		playObserver  : null,
		isNearViewport: false,
		playerReady   : false,
		isPlaying     : false,

		injectIframe( figure ) {
			this.figure = figure;

			const existingIframe = figure.querySelector( 'iframe' );
			if ( existingIframe ) {
				this.iframe = existingIframe;
				this.observeViewport( figure );
				return existingIframe;
			}

			const src = figure.dataset.vimeoSrc;
			if ( ! src ) return null;

			const iframe = document.createElement( 'iframe' );
			this.iframe = iframe;

			const onMessage = event => {
				let data;

				try {
					data = JSON.parse( event.data );
				} catch ( e ) {
					return;
				}

				if ( event.source === iframe.contentWindow && data && 'ready' === data.event ) {
					window.removeEventListener( 'message', onMessage );
					this.playerReady = true;
					this.reconcile();
				}
			};

			window.addEventListener( 'message', onMessage );

			iframe.src = src;
			iframe.setAttribute( 'frameborder', '0' );
			iframe.setAttribute( 'allowfullscreen', '' );
			iframe.setAttribute( 'title', 'Background video' );
			figure.prepend( iframe );

			this.observeViewport( figure );
			return iframe;
		},

		observeViewport( figure ) {
			if ( this.playObserver ) return;

			this.playObserver = new IntersectionObserver( entries => {
				entries.forEach( entry => {
					this.isNearViewport = entry.isIntersecting;
					this.reconcile();
				});
			}, {
				rootMargin: '100px',
				threshold : 0
			});

			this.playObserver.observe( figure );
		},

		playVideo( iframe ) {
			if ( ! iframe ) return;

			try {
				iframe.contentWindow.postMessage( JSON.stringify({ method: 'play' }), '*' );
				this.isPlaying = true;
				this.hidePoster( this.figure );
			} catch ( e ) {}
		},

		pauseVideo( iframe ) {
			if ( ! iframe ) return;

			try {
				iframe.contentWindow.postMessage( JSON.stringify({ method: 'pause' }), '*' );
				this.isPlaying = false;
			} catch ( e ) {}
		},

		hidePoster( figure ) {
			const poster = figure.querySelector( '[data-um-poster]' );
			if ( poster ) poster.classList.add( 'um-poster--hidden' );
		},

		reconcile() {
			if ( ! this.iframe ) return;

			if ( this.isNearViewport && this.playerReady && ! this.isPlaying ) this.playVideo( this.iframe );
			else if ( this.isPlaying && ( ! this.isNearViewport || ! this.playerReady ) ) this.pauseVideo( this.iframe );
		},
	}) );
});
